import { render, staticRenderFns } from "./Many.vue?vue&type=template&id=a6fa212a"
import script from "./Many.vue?vue&type=script&lang=ts"
export * from "./Many.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports